import { format } from 'fecha';

export default (item) => {
    let date_str = '';
    if (item.start_date && item.end_date) {
        let s = [];
        let e = [];


        if ((item.thetype === '1' || item.thetype === '2') && item.text) {
            date_str = item.text;
        } else if (item.only_one_day) {
            e = new Date(item.end_date);
            date_str = format(e, 'D MMMM YYYY');
        } else {
            s = new Date(item.start_date);
            e = new Date(item.end_date);

            if (e.getFullYear() === s.getFullYear() && e.getMonth() === s.getMonth()) {
                date_str = format(s, 'D') + '–' + format(e, 'D MMMM YYYY');
            }
            else if (e.getFullYear() === s.getFullYear()) {
                date_str = format(s, 'D MMMM') + '–' + format(e, 'D MMMM YYYY');
            }
            else {
                date_str = format(s, 'D MMMM YYYY') + '–' + format(e, 'D MMMM YYYY');
            }
        }
    }

    // quick and dirty way to restore original label for all day events (Festival.vue line 247/WhatsOn line 148 for more info)
    if (item.time) date_str = date_str +', '+ item.time.replace('0all day', 'all day');
    // date_str = date_str + ' ------------- ' + item.start_date + ',' + item.end_date

    return date_str;
}
